export default __webpack_public_path__ + "static/media/logo-business-central.8639cc0d.png";